<template>
  <div class="job-experience" v-if="job">
    <div class="header">
      <h1>{{ job.title }}</h1>
      <h2>{{ job.company }}</h2>
      <p class="duration">{{ job.duration }}</p>
    </div>

    <div class="section">
      <h3>Description</h3>
      <p>{{ job.description }}</p>
    </div>

    <div v-if="job.positions" class="career-progression">
      <h3>Career Progression</h3>
      
      <div v-for="(position, index) in job.positions" 
           :key="index" 
           class="position-card">
        <div class="position-header">
          <h4>{{ position.title }}</h4>
          <span class="position-duration">{{ position.duration }}</span>
        </div>
        
        <p v-if="position.description?.trim()" class="position-description">{{ position.description }}</p>
        
        <div v-if="position.responsibilities?.length" class="responsibilities">
          <h5>Key Responsibilities:</h5>
          <BulletList :items="position.responsibilities" />
        </div>

        <div v-if="position.results?.length" class="results">
          <h5>Results:</h5>
          <BulletList :items="position.results" item-class="result-item" />
        </div>

        <div v-if="position.technologies?.length" class="position-technologies">
          <h5>Technologies:</h5>
          <div class="tech-tags">
            <span v-for="tech in position.technologies" 
                  :key="tech" 
                  class="tech-tag">
              {{ tech }}
            </span>
          </div>
        </div>

        <ItemLinks :items="position" compact />
      </div>
    </div>

    <div v-else>
      <div v-if="job.responsibilities?.length" class="section">
        <h3>Key Responsibilities</h3>
        <BulletList :items="job.responsibilities" />
      </div>

      <div v-if="job.results?.length" class="section">
        <h3>Results</h3>
        <BulletList :items="job.results" item-class="result-item" />
      </div>

      <ItemLinks :items="job" title="Ссылки" heading-tag="h3" />
    </div>

    <ItemLinks
      v-if="job.positions"
      :items="job"
      title="Ссылки"
      heading-tag="h3"
      class="section"
    />

    <router-link to="/career" class="back-link">
      <span class="arrow">←</span> Назад в Career
    </router-link>
  </div>
  <div v-else class="not-found">
    <h1>Job Not Found</h1>
    <router-link to="/career" class="back-link">
      <span class="arrow">←</span> Назад в Career
    </router-link>
  </div>
</template>

<script>
import { jobs } from '../stores/jobs';
import BulletList from '../components/BulletList.vue';
import ItemLinks from '../components/ItemLinks.vue';

export default {
  name: 'JobExperience',
  components: {
    BulletList,
    ItemLinks,
  },
  data() {
    return {
      job: jobs.find(job => job.id === this.$route.params.id)
    };
  }
};
</script>

<style scoped>
.job-experience {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #1e1e1e;
  color: #d4d4d4;
  border-radius: 8px;
}

.header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #333;
}

h1 {
  color: #4ec9b0;
  margin: 0;
}

h2 {
  color: #9cdcfe;
  margin: 0.5rem 0;
}

h3 {
  color: #569cd6;
  margin: 1rem 0;
}

.duration {
  color: #6a9955;
  margin: 0.5rem 0;
}

.section {
  margin: 2rem 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

li::before {
  content: "→";
  position: absolute;
  left: 0;
  color: #4ec9b0;
}

.result-item::before {
  content: "★";
  color: #dcdcaa;
}

.technologies {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tech-tag {
  background-color: #2d2d2d;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  color: #ce9178;
}

.back-link {
  display: inline-flex;
  align-items: center;
  margin-top: 2rem;
  color: #4ec9b0;
  text-decoration: none;
  transition: color 0.3s;
  gap: 0.5rem;
}

.job-link {
  color: #9cdcfe;
  text-decoration: none;
}

.job-link:hover {
  color: #4ec9b0;
}

.back-link:hover {
  color: #9cdcfe;
}

.arrow {
  font-size: 1.2rem;
}

.not-found {
  text-align: center;
  padding: 4rem 2rem;
  color: #d4d4d4;
}

.career-progression {
  margin: 2rem 0;
}

.position-card {
  background-color: #2d2d2d;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
}

.position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

h4 {
  color: #4ec9b0;
  margin: 0;
  font-size: 1.2rem;
}

.position-duration {
  color: #6a9955;
  font-size: 0.9rem;
}

.position-description {
  color: #d4d4d4;
  margin: 1rem 0;
}

h5 {
  color: #569cd6;
  margin: 1rem 0 0.5rem 0;
  font-size: 1rem;
}

.position-technologies {
  margin-top: 1.5rem;
}

.tech-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.responsibilities ul {
  margin-top: 0.5rem;
}
</style> 